
  <section
    class="w-full py-24 mx-auto gap-10"
  >

  <div class="w-11/12 mx-auto text-center max-w-3xl">

   
   <h2 class="text-4xl font-light mb-6">
Start Your Global Capability Center Journey    </h2>

    <p class="text-lg text-gray-700 mb-8">
Speak with CIC experts to explore how a Global Capability Center can accelerate delivery, reduce vendor dependency, and strengthen enterprise platform ownership.    </p>

    <article class="bg-white rounded-md p-6">
      <form
        class="grid gap-2"
        [formGroup]="contactForm"
        (ngSubmit)="onSubmit()"
      >
        <div>
          <input
            type="text"
            pInputText
            formControlName="Name"
            placeholder="Your Name"
            class="w-full mb-1"
          />
          @if( (contactForm.controls['Name'].touched ||
          contactForm.controls['Name'].dirty) &&
          contactForm.controls['Name'].invalid){
          @if(contactForm.controls['Name'].hasError('required')){
          <small
            class="error_message ml-1 text-red-err rounded-lg w-fit capitalize"
            >name is required.</small
          >
          } @if(contactForm.controls['Name'].hasError('pattern')){
          <small
            class="error_message ml-1 text-red-err rounded-lg w-fit capitalize"
            >Invalid name format.</small
          >
          } }
        </div>

        <div>
          <input
            type="text"
            pInputText
            formControlName="Number"
            placeholder="Your Phone Number"
            class="w-full mb-1"
          />
          @if( (contactForm.controls['Number'].touched ||
          contactForm.controls['Number'].dirty) &&
          contactForm.controls['Number'].invalid){
          @if(contactForm.controls['Number'].hasError('required')){
          <small
            class="error_message ml-1 text-red-err rounded-lg w-fit capitalize"
            >Phone is required.</small
          >
          } @if(contactForm.controls['Number'].hasError('pattern')){
          <small
            class="error_message ml-1 text-red-err rounded-lg w-fit capitalize"
            >Invalid name format.</small
          >
          } }
        </div>

        <div>
          <input
            formControlName="Email"
            pInputText
            placeholder="Email Address"
            type="email"
            class="w-full mb-1"
          />
          @if( (contactForm.controls['Email'].touched ||
          contactForm.controls['Email'].dirty) &&
          contactForm.controls['Email'].invalid){
          @if(contactForm.controls['Email'].hasError('required')){
          <small
            class="error_message ml-1 text-red-err rounded-lg w-fit capitalize"
            >Email is required.</small
          >
          } @if(contactForm.controls['Email'].hasError('email')){
          <small
            class="error_message ml-1 text-red-err rounded-lg w-fit capitalize"
            >Invalid Email format.</small
          >
          } }
        </div>
        <div>
          <input
            formControlName="Subject"
            pInputText
            placeholder="Subject"
            type="text"
            class="w-full mb-1"
          />
          @if( (contactForm.controls['Subject'].touched ||
          contactForm.controls['Subject'].dirty) &&
          contactForm.controls['Subject'].invalid){
          @if(contactForm.controls['Subject'].hasError('required')){
          <small
            class="error_message ml-1 text-red-err rounded-lg w-fit capitalize"
            >Subject is required.</small
          >
          } @if(contactForm.controls['Subject'].hasError('pattern')){
          <small
            class="error_message ml-1 text-red-err rounded-lg w-fit capitalize"
            >Invalid Subject format.</small
          >
          } }
        </div>
        <div>
          <textarea
            rows="5"
            cols="30"
            pInputTextarea
            formControlName="Message"
            placeholder="Message"
            class="w-full"
          ></textarea>
          @if( (contactForm.controls['Message'].touched ||
          contactForm.controls['Message'].dirty) &&
          contactForm.controls['Message'].invalid){
          @if(contactForm.controls['Message'].hasError('required')){
          <small
            class="error_message ml-1 text-red-err rounded-lg w-fit capitalize"
            >Message is required.</small
          >
          } @if(contactForm.controls['Message'].hasError('maxlength')){
          <small
            class="error_message ml-1 text-red-err rounded-lg w-fit capitalize"
          >
            Max letter is 300.</small
          >
          } }
        </div>
        <button
          type="submit"
          class="py-2 bg-primary hover:bg-primary-600 ml-auto text-white rounded-full px-6 flex items-center gap-2"
        >
          Send
        </button>
      </form>
    </article>
    </div>

  </section>
